export const API_ERRORS = {
	POLICY_HOLDER_EXISTS: `POLICY_HOLDER_EXISTS`,
	QUOTE_RETRIEVAL_FAILED: `QUOTE_RETRIEVAL_FAILED`,
	QUOTE_EXECUTION_ERROR: `QUOTE_EXECUTION_ERROR`,
	CONTACT_VALIDATION_MESSAGE: `CONTACT_VALIDATION_MESSAGE`,
	PAYROLLDEDUCT_VALIDATION_MESSAGE: `PAYROLLDEDUCT_VALIDATION_MESSAGE`,
	ME_SALES_VALIDATION_MESSAGE: 'ME_SALES_VALIDATION_MESSAGE'
};
